import React from 'react';

function AngleRightIcon({ color = '#D3A925' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 15 15">
      <g clipPath="url(#clip0_4186_28418)">
        <path
          fill={color}
          d="M3.677 13.538c0-.232.092-.454.256-.618L8.41 8.445a1.458 1.458 0 000-2.063L3.939 1.91A.875.875 0 015.176.672l4.47 4.47a3.212 3.212 0 010 4.537L5.17 14.154a.875.875 0 01-1.493-.616z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4186_28418">
          <path fill="#fff" d="M0 0H14V14H0z" transform="translate(.13 .413)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default AngleRightIcon;
